import { graphql } from '@app/graphql/types';

export const OnlineOrderStateEventFragment = graphql(`
  fragment OnlineOrderStateEventItem on OnlineOrderStateEvent {
    id
    state
    timestamp
  }
`);

export const OnlineOrderProductsFragment = graphql(`
  fragment OnlineOrderProductsItem on OnlineOrderProduct {
    id
    title
    quantity
    discountable
    menuProduct {
      id
      images
      code
      section {
        name
        id
        code
        description
        timeRule {
          __typename
          ... on MenuSectionAlwaysTimeRule {
            type
          }
          ... on MenuSectionRangeTimeRule {
            type
            start
            end
            isAllDays
            daysOfWeek
          }
        }
      }
      discountable
    }

    configurations {
      id
      title
      value
      price

      menuProductConfigurationId
      menuProductConfigurationValueId
    }
  }
`);

export const OnlineOrderFragment = graphql(`
  fragment OnlineOrderItem on Storefront_OnlineOrder {
    id

    userState
    confirmationState
    deliveryMode
    state

    estimatedDuration
    deliveryFeeCalculationStatus
    streetAddress
    streetAddress2
    addressLocality
    addressRegion
    postalCode
    addressCountry

    expectedTime

    guestName
    email
    phone
    message
    paymentMethod
    
    invoice {
      paymentURL
    }

    basePrice
    deliveryPrice
    deliveryDiscount
    pickupDiscount
    totalPrice

    createdAt
    updatedAt
    userCreatedAt

    events {
      ...OnlineOrderStateEventItem
    }

    onlineOrderProducts {
      ...OnlineOrderProductsItem
    }

    branch {
      ...BranchItem
    }

    manualTransferProofImageOrigin
    manualTransferProofImageThumbnail
    manualTransferSenderName
    manualTransferProofSubmittedAt
    manualTransferConfirmedAt
    manualTransferRejectedAt
    manualTransferRejectionReason
  }
`);
